import { createContext } from 'react';

import type { FireFeedCardAnalyticsEvent } from '../useFeedCardAnalyticsEvents.ts';

type FeedCardContextType = {
	fireAnalyticsEvent: FireFeedCardAnalyticsEvent;
};

export const FeedCardContext = createContext<FeedCardContextType>({
	fireAnalyticsEvent: () => {},
});
